export default "__VITE_ASSET__7g7J2w33__"